import { ActionReducerMap } from '@ngrx/store';

import { IJobListingTypeFeatureState } from './job-listing-type.reducer';
import * as fromEntity from './job-listing-type.reducer';

export * from './job-listing-type.messages';
export const reducers: ActionReducerMap<IJobListingTypeFeatureState> = {
  entityState: fromEntity.entityReducer,
};
